/**
 * @generated SignedSource<<1ef397b90dbdb291e008cbe273939633>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type serviceDocumentationRowRefetchQuery$variables = {
  id: string;
};
export type serviceDocumentationRowRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"ServiceDocumentationRow_serviceDocumentationQuery">;
  } | null;
};
export type serviceDocumentationRowRefetchQuery = {
  variables: serviceDocumentationRowRefetchQuery$variables;
  response: serviceDocumentationRowRefetchQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "serviceDocumentationRowRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ServiceDocumentationRow_serviceDocumentationQuery"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "serviceDocumentationRowRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "month",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "serviceDocumentationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LastUploadedFile",
                "kind": "LinkedField",
                "name": "lastUploadedFile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "filename",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mimeType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pathInStorage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "ServiceDocumentation",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f5ac4be050fe9b15d897f5c4ccc68f6d",
    "id": null,
    "metadata": {},
    "name": "serviceDocumentationRowRefetchQuery",
    "operationKind": "query",
    "text": "query serviceDocumentationRowRefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...ServiceDocumentationRow_serviceDocumentationQuery\n    id\n  }\n}\n\nfragment ServiceDocumentationRow_serviceDocumentationQuery on ServiceDocumentation {\n  id\n  month\n  serviceDocumentationId\n  lastUploadedFile {\n    filename\n    mimeType\n    pathInStorage\n  }\n}\n"
  }
};
})();

(node as any).hash = "3ba7bbf719f025e745f0bc591455aaec";

export default node;
